<template>
  <div class="content-container">
    <!-- S 立即购买 -->
    <div class="button-buy-wrap button-buy--qrcode button-buy--suit buy-now">
      <div class="game-box-btn game-buy-btn">
        <div class="nt-button nt-button--default">
          <a href="javascript:" target="_self">
            <i class="button-icon">
              <svg
                id="right-stroke-arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 60 60"
                aria-labelledby="right-stroke-arrow"
                role="presentation"
                fill="currentColor"
              >
                <g>
                  <g>
                    <path
                      d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
	l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
	c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                      fill="currentColor"
                    ></path>
                  </g>
                </g>
              </svg>
            </i>
            立即购买
          </a>
        </div>
      </div>
      <div class="popbox buy-popbox">
        <div class="button-buy-inner">
          <div>
            <div class="nt-button nt-button--default game-box-btn--store">
              <a class="button-wechat-store">
                微信官方商城
              </a>
            </div>
            <div class="qrcode-box">
              <picture>
                <source :srcset="buyLinkList.wx" type="image/png" />
                <img :src="buyLinkList.wx" alt="" class="" />
              </picture>
            </div>
            <div class="qrcode-scan">
              <p>打开微信扫一扫</p>
            </div>
          </div>
          <div class="game-box-btn game-box-btn--top">
            <div class="nt-button nt-button--default">
              <a :href="buyLinkList.jd" target="_blank">
                <i class="button-icon">
                  <svg
                    id="right-stroke-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    aria-labelledby="right-stroke-arrow"
                    role="presentation"
                    fill="currentColor"
                  >
                    <g>
                      <g>
                        <path
                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
	l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
	c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </i>
                京东官方旗舰店
              </a>
            </div>
          </div>
          <div class="game-box-btn game-box-btn--bottom">
            <div class="nt-button nt-button--default">
              <a :href="buyLinkList.tm" target="_blank">
                <i class="button-icon">
                  <svg
                    id="right-stroke-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    aria-labelledby="right-stroke-arrow"
                    role="presentation"
                    fill="currentColor"
                  >
                    <g>
                      <g>
                        <path
                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
	l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
	c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </i>
                天猫官方旗舰店
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- E 立即购买 -->
    <main class="main-container">
      <div class="hero">
        <div class="hero__bg">
          <div class="hero__bg-in"></div>
        </div>
        <p class="hero__logo">
          <a href="/software"
            ><img src="../../assets/img/common/logo_switch.svg"
          /></a>
        </p>
        <div class="hero__in">
          <div class="hero__body">
            <div class="hero-header">
              <h1 class="hero__title">
                <img src="../../assets/img/top/hero/logo.svg" />
              </h1>

              <p class="hero__date">
                <img src="../../assets/img/top/hero/date.svg" />
              </p>
            </div>
            <div class="hero__chara">
              <picture>
                <source media="(max-width: 759px)" srcset="" />
                <img src="../../assets/img/top/hero/chara.png" />
              </picture>
            </div>
            <div class="hero__switch">
              <picture>
                <source media="(max-width: 759px)" srcset="" />
                <img src="../../assets/img/top/hero/switch.png" />
              </picture>
            </div>
            <!-- <div class="hero__movie temp-hide">
              <div class="hero__movie-shadow"></div>
              <a href="/awuxa/movie/index.html" class="hero-movie-btn">
                <div class="hero-movie-btn__body">
                  <div class="hero-movie-btn__thumb">
                    <div class="hero-movie-btn__img">
                      <img src="../../assets/img/top/hero/movie_thumb.png" />
                    </div>

                    <div class="hero-movie-btn__ico">
                      <i class="c-svg hero-movie-btn__ico-play"
                        ><svg role="img">
                          <use xlink:href="/awuxa/sprite.svg#play"></use></svg
                      ></i>
                    </div>
                  </div>
                  <div class="hero-movie-btn__desc">
                    <p class="hero-movie-btn__label">
                      <picture>
                        <source
                          media="(max-width: 759px)"
                          srcset="../../assets/img/top/hero/movie_label.svg"
                        />
                        <img src="../../assets/img/top/hero/movie_label.svg" />
                      </picture>
                    </p>
                  </div>
                </div>
              </a>
            </div> -->

            <div class="hero__lesson">
              <a
                target="_blank"
                href="https://www.nintendoswitch.com.cn/topics/c374f485-4d3a-4420-b207-c773718ab55c"
                class="hero-lesson-btn"
              >
                <div class="hero-lesson-btn__img">
                  <picture>
                    <source
                      media="(max-width: 759px)"
                      srcset="../../assets/img/top/hero/bnr_lesson_sp.png"
                    />
                  </picture>
                  <img
                    src="../../assets/img/top/hero/bnr_lesson_pc.png"
                    alt="体验课程免费发布中"
                  />
                </div>
                <div class="hero-interview__new">
                  <img src="../../assets/img/common/ico_new2.svg" alt="NEW" />
                </div>
              </a>
            </div>
            <div class="hero__movie-s">
              <a
                href="./movie/index.html?item=movie02"
                class="hero-movie-btn-s"
              >
                <div class="hero-movie-btn-s__body">
                  <div class="hero-movie-btn-s__thumb">
                    <div class="hero-movie-btn-s__img">
                      <img
                        src="../../assets/img/top/hero/thumb02_l.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                  <p class="hero-movie-btn-s__label">
                    <img
                      src="../../assets/img/top/hero/movie_label.svg"
                      alt="介绍影片"
                    />
                  </p>
                </div>
                <div class="hero-movie-btn__ico">
                  <i class="c-svg hero-movie-btn__ico-play"
                    ><svg role="img">
                      <use xlink:href="/awuxa/sprite.svg#play"></use></svg
                  ></i>
                </div>
              </a>
            </div>
            <div class="hero__yoiko">
              <a
                href="javascript:void(0);"
                class="hero-yoiko-btn"
                @click="showVideoModal1 = true"
              >
                <div class="hero-movie-btn-s__body">
                  <div class="hero-movie-btn-s__thumb">
                    <div class="hero-movie-btn-s__img">
                      <img
                        src="../../assets/img/movie/yoiko_thum2.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                  <p
                    class="hero-movie-btn-s__label hero-movie-btn-s__label--yoiko"
                  >
                    <img
                      src="../../assets/img/top/hero/movie_label2.svg"
                      alt="新广告"
                    />
                  </p>
                </div>
                <div class="hero-interview__new">
                  <img src="../../assets/img/common/ico_new2.svg" alt="NEW" />
                </div>
                <div class="hero-movie-btn__ico">
                  <i class="c-svg hero-movie-btn__ico-play"
                    ><svg role="img">
                      <use xlink:href="/awuxa/sprite.svg#play"></use></svg
                  ></i>
                </div>
              </a>
            </div>
            <div class="hero-interview">
              <a
                target="_blank"
                href="https://www.nintendo.co.jp/interview/awuxa/zh-CN/"
                ><img
                  src="../../assets/img/top/hero/bnr_interview.png?interview"
                  alt=""
              /></a>
              <div class="hero-interview__new">
                <img src="../../assets/img/common/ico_new2.svg" alt="NEW" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lead">
        <div class="lead-bg">
          <div class="lead-bg__spacer"></div>
          <div class="lead-bg__screen lead-screen">
            <simple-slick
              :class-name="'lead-screen__body js-lead-slide slick-initialized slick-slider slick-track'"
              :list="leadList1"
              :slides-to-show="leadShowNum"
              :time="leadTime"
              :animate-mode="'time'"
            >
              <template slot="slickItem" slot-scope="data">
                <div
                  class="lead-screen__item slick-slide"
                  :style="data.itemStyle"
                >
                  <img :src="data.item.src" @load="setLeadHeight" />
                </div>
              </template>
            </simple-slick>
          </div>
          <div class="lead-bg__screen lead-screen">
            <simple-slick
              :class-name="'lead-screen__body js-lead-slide slick-initialized slick-slider slick-track'"
              :list="leadList2"
              :pos="-1"
              :slides-to-show="leadShowNum"
              :time="leadTime"
              :animate-mode="'time'"
              @resetStyle="setLeadHeight"
            >
              <template slot="slickItem" slot-scope="data">
                <div
                  class="lead-screen__item slick-slide"
                  :style="data.itemStyle"
                >
                  <img :src="data.item.src" @load="setLeadHeight" />
                </div>
              </template>
            </simple-slick>
          </div>
        </div>
        <div class="lead__in">
          <div class="lead__body">
            <div class="lead__main">
              <div class="lead-chara">
                <div class="lead-chara__img">
                  <img src="../../assets/img/node/input_3.png" />
                </div>
                <div class="lead-chara__img">
                  <img src="../../assets/img/node/mono_3.png" />
                </div>
                <div class="lead-chara__img">
                  <img src="../../assets/img/node/output_2.png" />
                </div>
                <div class="lead-chara__img">
                  <img src="../../assets/img/node/mono_4.png" />
                </div>
                <div class="lead-chara__img">
                  <img src="../../assets/img/node/middle_17.png" />
                </div>
                <div class="lead-chara__img">
                  <img src="../../assets/img/node/mono_13.png" />
                </div>
              </div>
              <div class="lead-main">
                <div class="lead-main__in">
                  <h2 class="lead-main__title">
                    <picture>
                      <source
                        media="(max-width: 759px)"
                        srcset="../../assets/img/top/lead/title_sp.svg"
                      />
                      <img src="../../assets/img/top/lead/title.svg" />
                    </picture>
                  </h2>
                  <p class="lead-main__text">
                    玩游戏带来快乐，<br
                      class="u-hide-tab-pc"
                    />制作游戏也能带来快乐。<br
                      class="u-hide-sp"
                    />人人都能体验游戏制作，<br
                      class="u-hide-tab-pc"
                    />要来亲自体验一下游戏程序设计吗？
                  </p>
                  <p class="lead-main__link">
                    <a
                      href="javascript:void(0);"
                      class="lead-main__btn js-modal-programming-triger"
                      @click="showModal"
                      ><img src="../../assets/img/top/lead/link_text.svg"
                    /></a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lead-bottom-space" :style="leadBottomStyle"></div>
      </div>
      <div class="lesson">
        <div class="lesson__in">
          <div class="lesson__body">
            <div class="lesson__chara01">
              <img src="../../assets/img/top/lesson/chara01.png" />
            </div>
            <div class="lesson__chara02">
              <picture>
                <source
                  media="(max-width: 759px)"
                  srcset="../../assets/img/top/lesson/chara02_sp.png"
                />
                <img src="../../assets/img/top/lesson/chara02.png" />
              </picture>
            </div>
            <div class="lesson__header">
              <h3 class="lesson__header-title">
                <img src="../../assets/img/top/lesson/title.svg" />
              </h3>

              <p class="lesson__header-lead">
                附带导航可以让你轻松简单地按照课程指导完成游戏制作！
              </p>
            </div>
            <div class="lesson__main lesson-main">
              <div class="lesson-main__bg">
                <img src="../../assets/img/top/lesson/switch.png" />
              </div>
              <div class="lesson-main__body">
                <div class="lesson-main-movie js-viewport-movie">
                  <video
                    playsinline
                    loop
                    autoplay
                    muted
                    src="../../assets/movie/top_lesson.mp4"
                    poster="../../assets/movie/top_lesson.jpg"
                  ></video>
                </div>
              </div>
            </div>
            <div class="lesson__footer">
              <div class="lesson__footer-btn">
                <a href="/awuxa/lesson/index.html" class="lesson-footer-btn">
                  <div class="lesson-footer-btn__body">
                    <div class="lesson-footer-btn__bg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 6120 1880"
                      >
                        <path
                          d="M5960,489.49H3782.72c-10.27-30-26-59.23-47.2-87.42-38.12-50.76-92.22-96.08-160.8-134.7-64.82-36.5-139.53-65.3-220.64-85.57A144.16,144.16,0,0,0,3075,147c-5-.05-10-.09-15-.09s-10,0-15,.09a144.16,144.16,0,0,0-279.12,34.83c-81.11,20.27-155.82,49.07-220.64,85.57-68.58,38.62-122.68,83.94-160.8,134.7-21.18,28.19-36.93,57.41-47.2,87.42H160c-71.68,0-130,58.32-130,130V1718.38a130.14,130.14,0,0,0,130,130H5960a130.14,130.14,0,0,0,130-130V619.49C6090,547.81,6031.68,489.49,5960,489.49Zm-2240.19,3.6.39.93Zm1.5,3.6c.17.42.34.83.5,1.24C3721.65,497.52,3721.48,497.11,3721.31,496.69Zm1.44,3.61c.18.46.36.93.53,1.39C3723.11,501.23,3722.93,500.76,3722.75,500.3Zm1.37,3.62c.19.49.36,1,.54,1.47C3724.48,504.9,3724.31,504.41,3724.12,503.92Zm1.31,3.62.52,1.53Zm1.23,3.64.51,1.55Zm1.17,3.63.48,1.59Zm1.09,3.65c.16.54.31,1.07.46,1.6C3729.23,519.53,3729.08,519,3728.92,518.46Zm1,3.66.44,1.61Zm1,3.66c.14.54.28,1.08.41,1.62C3731.19,526.86,3731.05,526.32,3730.91,525.78Zm.9,3.69c.12.53.25,1.07.37,1.6C3732.06,530.54,3731.93,530,3731.81,529.47Zm.82,3.69c.12.53.23,1.06.34,1.59C3732.86,534.22,3732.75,533.69,3732.63,533.16Zm.76,3.73c.1.51.21,1,.3,1.54C3733.6,537.91,3733.49,537.4,3733.39,536.89Zm.7,3.77c.09.48.17,1,.26,1.45C3734.26,541.63,3734.18,541.14,3734.09,540.66Zm.65,3.94c.06.4.13.8.19,1.2C3734.87,545.4,3734.8,545,3734.74,544.6ZM2400.19,493.09c-.13.32-.26.64-.4,1C2399.93,493.73,2400.06,493.41,2400.19,493.09Zm-1.5,3.6-.51,1.26Zm-1.44,3.61-.54,1.39Zm-1.37,3.62c-.19.49-.36,1-.54,1.47C2395.52,504.9,2395.69,504.41,2395.88,503.92Zm-1.31,3.62-.52,1.53Zm-1.23,3.64-.51,1.55Zm-1.17,3.63-.48,1.59Zm-1.09,3.65c-.16.54-.31,1.07-.46,1.6C2390.77,519.53,2390.92,519,2391.08,518.46Zm-1,3.66-.44,1.61Zm-1,3.66c-.14.54-.28,1.08-.41,1.62C2388.81,526.86,2389,526.32,2389.09,525.78Zm-.9,3.68c-.12.54-.25,1.08-.37,1.62C2387.94,530.54,2388.07,530,2388.19,529.46Zm-.82,3.7c-.12.53-.23,1.06-.34,1.59C2387.14,534.22,2387.25,533.69,2387.37,533.16Zm-.76,3.73c-.1.51-.21,1-.3,1.54C2386.4,537.91,2386.51,537.4,2386.61,536.89Zm-.7,3.77c-.09.48-.17,1-.26,1.45C2385.74,541.63,2385.82,541.14,2385.91,540.66Zm-.65,3.94c-.06.4-.13.8-.19,1.2C2385.13,545.4,2385.2,545,2385.26,544.6Z"
                        />
                      </svg>
                    </div>
                    <div class="lesson-footer-btn__base-clip">
                      <div class="lesson-footer-btn__base"></div>
                    </div>
                    <div class="lesson-footer-btn__label">
                      <img src="../../assets/img/top/lesson/btn_label.svg" />
                    </div>

                    <div class="lesson-footer-btn__arrow">
                      <i class="c-svg lesson-footer-btn__arrow-ico"
                        ><svg role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#arw_right"
                          ></use></svg
                      ></i>
                    </div>
                    <div class="lesson-footer-btn__frame">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 6120 1880"
                      >
                        <path
                          d="M5960,489.49H3782.72c-10.27-30-26-59.23-47.2-87.42-38.12-50.76-92.22-96.08-160.8-134.7-138-77.7-320.77-120.49-514.72-120.49s-376.74,42.79-514.72,120.49c-68.58,38.62-122.68,83.94-160.8,134.7-21.18,28.19-36.93,57.41-47.2,87.42H160c-71.68,0-130,58.32-130,130V1718.38a130.14,130.14,0,0,0,130,130H5960a130.14,130.14,0,0,0,130-130V619.49C6090,547.81,6031.68,489.49,5960,489.49ZM6030,670v888.39a70.08,70.08,0,0,1-70,70H160a70.08,70.08,0,0,1-70-70V619.49c0-.92,0-1.84,0-2.76s.11-2,.19-3c.13-1.6.32-3.18.56-4.75,0-.28.09-.56.13-.84a69.66,69.66,0,0,1,11.6-28.54,72,72,0,0,1,5.38-6.8l.4-.45A69.84,69.84,0,0,1,160,549.49H2384.56c.16-1.23.33-2.45.51-3.68.06-.4.13-.8.19-1.21l.39-2.48c.09-.48.17-1,.26-1.45.13-.75.26-1.49.4-2.23.09-.52.2-1,.3-1.55.14-.71.27-1.42.42-2.13.11-.53.22-1.06.34-1.6s.29-1.38.45-2.07.25-1.08.37-1.62c.16-.69.32-1.37.49-2.06.13-.54.27-1.08.41-1.62s.34-1.36.52-2l.44-1.61c.18-.69.37-1.37.57-2s.3-1.07.46-1.61c.2-.69.4-1.37.61-2.06l.48-1.59.66-2.08.51-1.56c.23-.7.47-1.4.71-2.1l.52-1.53c.25-.72.51-1.43.77-2.14.18-.5.35-1,.54-1.49.27-.74.55-1.47.83-2.21l.54-1.4c.3-.78.62-1.57.93-2.35.17-.42.33-.84.51-1.26.36-.88.72-1.75,1.09-2.63.14-.32.28-.65.41-1,.52-1.2,1-2.4,1.58-3.59h0q1.39-3.11,2.9-6.21l.21-.44q1.45-3,3-5.92c.13-.23.25-.47.37-.71,1-1.91,2-3.82,3.1-5.73l.47-.84c1.06-1.88,2.14-3.76,3.26-5.63.17-.3.35-.59.52-.88,1.12-1.88,2.27-3.74,3.45-5.61l.54-.84c1.2-1.88,2.43-3.77,3.69-5.64l.49-.72c1.3-1.92,2.62-3.84,4-5.76l.34-.46c1.43-2,2.88-4,4.38-6h0c33.11-44.07,81-83.93,142.27-118.45,62.51-35.2,135.51-62.88,217-82.29,84.91-20.23,175.17-30.48,268.29-30.48s183.38,10.25,268.28,30.48c81.49,19.41,154.49,47.09,217,82.29,61.29,34.52,109.16,74.38,142.27,118.45h0c1.5,2,2.95,4,4.38,6l.34.46q2,2.88,4,5.77l.48.7c1.26,1.88,2.49,3.77,3.69,5.65.18.28.36.56.53.84,1.18,1.86,2.34,3.74,3.46,5.61l.52.87c1.12,1.88,2.2,3.76,3.26,5.65.16.27.31.55.47.83,1.06,1.91,2.1,3.82,3.1,5.74l.36.7q1.54,3,3,5.92c.08.14.15.29.22.44q1.5,3.11,2.9,6.21h0c.54,1.19,1.06,2.39,1.58,3.59l.39.94c.38.89.75,1.78,1.11,2.66.17.42.34.83.5,1.25.32.79.64,1.57.94,2.36l.54,1.4c.28.74.56,1.47.83,2.21.19.5.36,1,.54,1.49.26.71.52,1.42.76,2.14.18.51.36,1,.53,1.53.24.7.48,1.4.71,2.1l.51,1.56.66,2.08.48,1.59c.21.69.41,1.37.61,2.06.16.54.31,1.07.46,1.61s.39,1.36.57,2l.44,1.61c.18.68.35,1.37.52,2s.28,1.08.41,1.62c.17.69.33,1.38.49,2.06s.25,1.08.37,1.61l.45,2.09c.12.53.23,1.06.34,1.59.15.71.28,1.42.42,2.13.1.52.21,1,.3,1.55.14.74.27,1.48.4,2.23.08.48.17,1,.26,1.45l.39,2.48c.06.41.13.81.19,1.21.18,1.23.35,2.45.51,3.68H5960a70.08,70.08,0,0,1,70,70Z"
                        />
                        <path
                          class="cls-1"
                          d="M90.93,608.13a69.66,69.66,0,0,1,11.6-28.54A69.66,69.66,0,0,0,90.93,608.13Z"
                        />
                        <path
                          class="cls-1"
                          d="M90.24,613.72c.13-1.6.32-3.18.56-4.75C90.56,610.54,90.37,612.12,90.24,613.72Z"
                        />
                        <path
                          class="cls-1"
                          d="M90.05,616.73c0-1,.11-2,.19-3C90.16,614.72,90.09,615.72,90.05,616.73Z"
                        />
                        <path
                          class="cls-1"
                          d="M90.8,609c0-.28.09-.56.13-.84C90.89,608.41,90.84,608.69,90.8,609Z"
                        />
                        <circle
                          class="lesson-footer-btn__frame-fill"
                          cx="2909.38"
                          cy="195.75"
                          r="144.13"
                        />
                        <path
                          d="M2909.38,359.88c-90.5,0-164.13-73.63-164.13-164.13s73.63-164.13,164.13-164.13,164.14,73.63,164.14,164.13S2999.89,359.88,2909.38,359.88Zm0-288.26a124.13,124.13,0,1,0,124.14,124.13A124.26,124.26,0,0,0,2909.38,71.62Z"
                        />
                        <circle cx="2858.85" cy="157.62" r="77.49" />
                        <path
                          d="M2858.85,249.92a92.31,92.31,0,1,1,92.31-92.3A92.41,92.41,0,0,1,2858.85,249.92Zm0-155a62.68,62.68,0,1,0,62.68,62.68A62.75,62.75,0,0,0,2858.85,94.94Z"
                        />
                        <circle
                          class="lesson-footer-btn__frame-fill"
                          cx="3210.62"
                          cy="195.75"
                          r="144.13"
                        />
                        <path
                          d="M3210.62,359.88c-90.51,0-164.14-73.63-164.14-164.13s73.63-164.13,164.14-164.13,164.13,73.63,164.13,164.13S3301.12,359.88,3210.62,359.88Zm0-288.26a124.13,124.13,0,1,0,124.13,124.13A124.27,124.27,0,0,0,3210.62,71.62Z"
                        />
                        <circle cx="3160.08" cy="157.62" r="77.49" />
                        <path
                          d="M3160.09,249.92a92.31,92.31,0,1,1,92.3-92.3A92.41,92.41,0,0,1,3160.09,249.92Zm0-155a62.68,62.68,0,1,0,62.67,62.68A62.75,62.75,0,0,0,3160.09,94.94Z"
                        />
                      </svg>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="node-slide-sec">
        <div class="node-slide-sec__in">
          <div class="node-slide-sec__body">
            <div class="node-slide-wrapper">
              <div class="node-slide-header">
                <div class="node-slide-header__balloon">
                  <img
                    src="../../assets/img/top/node-info/slide_title-balloon.svg"
                  />
                </div>

                <h3 class="node-slide-header__title">
                  <picture>
                    <source
                      media="(max-width: 759px)"
                      srcset="../../assets/img/top/node-info/slide_title_sp.svg"
                    />
                    <img src="../../assets/img/top/node-info/slide_title.svg" />
                  </picture>
                </h3>
              </div>
              <div class="node-slide-container">
                <div class="node-slide-container__bg">
                  <div class="node-slide-container__bg-in">
                    <div class="node-slide-container__bg-body"></div>
                    <div
                      class="node-slide-container__bg-arw node-slide-container__bg-arw--prev u-hide-tab-sp"
                    ></div>
                    <div
                      class="node-slide-container__bg-arw node-slide-container__bg-arw--next u-hide-tab-sp"
                    ></div>
                  </div>
                </div>
                <div class="node-slide-container__main">
                  <div
                    class="node-slide-container__main-bg-arw node-slide-container__main-bg-arw--prev u-hide-tab-sp"
                  ></div>
                  <div
                    class="node-slide-container__main-bg-arw node-slide-container__main-bg-arw--next u-hide-tab-sp"
                  ></div>
                  <div class="node-slide-container__main-slide">
                    <div class="node-slide">
                      <swiper
                        ref="swiper"
                        class="swiper-container node-slide__wrapper"
                        :options="swiperOption"
                      >
                        <swiper-slide>
                          <div class="swiper-slide node-slide__item">
                            <div class="node-slide-item">
                              <div class="node-slide-item__in">
                                <div class="node-slide-item__label">
                                  <picture>
                                    <source
                                      media="(max-width: 759px)"
                                      srcset="
                                        ../../assets/img/top/node-info/slide01_sp.png
                                      "
                                    />
                                    <img
                                      src="../../assets/img/top/node-info/slide01.png"
                                    />
                                  </picture>
                                </div>
                                <div
                                  class="node-slide-item__movie js-viewport-movie"
                                >
                                  <video
                                    class="js-node-slide-video0 js-node-slide-video"
                                    playsinline
                                    autoplay
                                    muted
                                    src="../../assets/movie/top_run.mp4"
                                    poster="../../assets/movie/top_run.jpg"
                                    @ended="slideNext($event)"
                                  ></video>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="swiper-slide node-slide__item">
                            <div class="node-slide-item">
                              <div class="node-slide-item__in">
                                <div class="node-slide-item__label">
                                  <picture>
                                    <source
                                      media="(max-width: 759px)"
                                      srcset="
                                        ../../assets/img/top/node-info/slide02_sp.png
                                      "
                                    />
                                    <img
                                      src="../../assets/img/top/node-info/slide02.png"
                                    />
                                  </picture>
                                </div>
                                <div
                                  class="node-slide-item__movie js-viewport-movie"
                                >
                                  <video
                                    class="js-node-slide-video1 js-node-slide-video"
                                    playsinline
                                    autoplay
                                    muted
                                    src="../../assets/movie/top_action.mp4"
                                    poster="../../assets/movie/top_action.jpg"
                                    @ended="slideNext($event)"
                                  ></video>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="swiper-slide node-slide__item">
                            <div class="node-slide-item">
                              <div class="node-slide-item__in">
                                <div class="node-slide-item__label">
                                  <picture>
                                    <source
                                      media="(max-width: 759px)"
                                      srcset="
                                        ../../assets/img/top/node-info/slide03_sp.png
                                      "
                                    />
                                    <img
                                      src="../../assets/img/top/node-info/slide03.png"
                                    />
                                  </picture>
                                </div>
                                <div
                                  class="node-slide-item__movie js-viewport-movie"
                                >
                                  <video
                                    class="js-node-slide-video2 js-node-slide-video"
                                    playsinline
                                    autoplay
                                    muted
                                    src="../../assets/movie/top_effect.mp4"
                                    poster="../../assets/movie/top_effect.jpg"
                                    @ended="slideNext($event)"
                                  ></video>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                      </swiper>
                      <div
                        slot="pagination"
                        class="js-node-slide-pagination"
                      ></div>
                    </div>
                  </div>
                  <div
                    slot="button-prev"
                    class="node-slide-container__main-arw node-slide-container__main-arw--prev"
                  >
                    <a
                      href="javascript:void(0);"
                      class="node-slide-container__arw js-node-slide-prev"
                      ><i class="c-svg node-slide-container__arw-ico"
                        ><svg role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#arw_left"
                          ></use></svg></i
                    ></a>
                  </div>
                  <div
                    slot="button-next"
                    class="node-slide-container__main-arw node-slide-container__main-arw--next"
                  >
                    <a
                      href="javascript:void(0);"
                      class="node-slide-container__arw js-node-slide-next"
                      ><i class="c-svg node-slide-container__arw-ico"
                        ><svg role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#arw_right"
                          ></use></svg></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="node">
        <div class="node-header">
          <div class="node-header__in">
            <div class="node-header__body">
              <h2 class="node-header__title">
                <picture>
                  <source
                    media="(max-width: 759px)"
                    srcset="../../assets/img/top/node-info/title_sp.svg"
                  />
                  <img src="../../assets/img/top/node-info/title.svg" />
                </picture>
              </h2>
            </div>
          </div>
        </div>

        <div class="node-chara">
          <div class="node-chara-slide">
            <template v-if="nodeList.length > 0">
              <div
                v-for="(list, index) in showNodeList"
                :key="index"
                class="node-chara__list js-chara-list slick-initialized slick-slider"
              >
                <div class="slick-list">
                  <simple-slick
                    :class-name="'slick-track'"
                    :list="list"
                    :slides-to-show="nodeShowNum"
                    :time="nodeTime"
                    :pos="index % 2 > 0 ? -1 : 1"
                    :animate-mode="'time'"
                  >
                    <template slot="slickItem" slot-scope="data">
                      <div
                        class="node-chara__item slick-slide slick-cloned"
                        :style="data.itemStyle"
                        data-slick-index="-10"
                        aria-hidden="true"
                      >
                        <a
                          href="javascript:void(0);"
                          class="node-chara__btn node-chara-btn js-node-chara-btn"
                          :data-id="data.item.id"
                          :data-category="data.item.category"
                          :class="{
                            'is-filtered':
                              nodeShowType !== 'all' &&
                              nodeShowType !== data.item.category,
                            'node-chara-btn--active':
                              nodeSelected &&
                              nodeSelected.id === data.item.id &&
                              activeNodeDelay
                          }"
                          tabindex="-1"
                          @click="clickNodeHandler(data.item)"
                        >
                          <div class="node-chara-btn__body">
                            <div class="node-chara-btn__bg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 100 100"
                              >
                                <circle cx="50" cy="50" r="48"></circle>
                              </svg>
                            </div>
                            <div
                              class="node-chara-btn__img"
                              :class="{
                                showNode:
                                  nodeShowType === 'all' ||
                                  nodeShowType === data.item.category,
                                filterNode:
                                  nodeShowType !== 'all' &&
                                  nodeShowType !== data.item.category
                              }"
                            >
                              <img :src="data.item.imgSrc" />
                            </div>
                            <div
                              class="node-chara-btn__cover"
                              :class="{
                                filterHover:
                                  nodeShowType === 'all' ||
                                  nodeShowType === data.item.category,
                                showHover:
                                  nodeShowType !== 'all' &&
                                  nodeShowType !== data.item.category
                              }"
                            ></div>
                          </div>
                        </a>
                      </div>
                    </template>
                  </simple-slick>
                </div>
              </div>
            </template>
            <div id="tgt-node-chara-slide"></div>
          </div>

          <div class="node-chara__in">
            <div class="node-chara__body js-node-chara-body">
              <div class="node-chara__info">
                <div
                  :class="nodeSelectedClass"
                  style="transform: translate(0px, 0px);"
                >
                  <div
                    :class="{
                      'node-chara-info__bg': true,
                      'node-chara-info__bg--active': nodeSelected
                    }"
                  >
                    <div class="node-chara-info__bg-in"></div>
                  </div>
                  <div v-show="!nodeSelected" class="node-chara-info__note">
                    <img src="../../assets/img/top/node-info/click.svg" />
                  </div>

                  <div
                    class="node-chara-info__chara"
                    :style="nodeSelectedStyle"
                  >
                    <img
                      :src="nodeSelectedImg"
                      class="node-chara-info__chara-img"
                    />
                  </div>
                  <div class="node-chara-info__name" :style="nodeSelectedStyle">
                    <p class="node-chara-info__name-label">
                      {{ nodeSelectedName }}
                    </p>
                  </div>
                  <div class="node-chara-info__type" :style="nodeSelectedStyle">
                    <p class="node-chara-info__type-label">
                      {{ nodeSelectedCategory }}
                    </p>
                  </div>
                  <div
                    class="node-chara-info__balloon"
                    :style="nodeSelectedStyle"
                  >
                    <div class="node-chara-info__balloon-ico">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 29 41"
                      >
                        <path
                          class="node-chara-info__balloon-svg"
                          d="M3.2,1.5,12,33.3c1.39,6,3.67,6,5.06,0L25.8,1.5Z"
                        />
                      </svg>
                    </div>
                    <div class="node-chara-info__balloon-in">
                      <p
                        class="node-chara-info__balloon-text"
                        v-html="nodeSelectedText"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="node-chara__filter">
            <div class="node-chara-filter">
              <div class="node-chara-filter__item">
                <a
                  href="javascript:void(0);"
                  :class="{
                    'node-chara-filter__btn--active': nodeShowType === 'all'
                  }"
                  class="node-chara-filter__btn node-chara-filter__btn--all js-node-chara-filter-btn"
                  data-category="all"
                  @click="filterNode('all')"
                >
                  <div class="node-chara-filter__ico">
                    <svg
                      class="u-hide-sp"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 29 41"
                    >
                      <path
                        class="node-chara-filter__ico-svg node-chara-filter__ico-svg--all"
                        d="M3.2,39.5,12,7.7c1.39-6,3.67-6,5.06,0L25.8,39.5Z"
                      />
                    </svg>
                  </div>
                  <div
                    class="node-chara-filter__btn-in node-chara-filter__btn-in--all"
                  >
                    <div class="node-chara-filter__label">
                      <i
                        class="c-svg node-chara-filter__label-ico node-chara-filter__label-ico--all"
                      >
                        <svg class="u-hide-sp" role="img">
                          <use xlink:href="/awuxa/sprite.svg#filter_all"></use>
                        </svg>
                        <svg class="u-hide-tab-pc" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_all_sp"
                          ></use>
                        </svg>
                      </i>
                    </div>
                  </div>
                </a>
              </div>
              <div class="node-chara-filter__item">
                <a
                  href="javascript:void(0);"
                  :class="{
                    'node-chara-filter__btn--active': nodeShowType === 'input'
                  }"
                  class="node-chara-filter__btn node-chara-filter__btn--input js-node-chara-filter-btn"
                  data-category="input"
                  @click="filterNode('input')"
                >
                  <div class="node-chara-filter__ico">
                    <svg
                      class="u-hide-sp"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 29 41"
                    >
                      <path
                        class="node-chara-filter__ico-svg node-chara-filter__ico-svg--input"
                        d="M3.2,39.5,12,7.7c1.39-6,3.67-6,5.06,0L25.8,39.5Z"
                      />
                    </svg>
                  </div>
                  <div
                    class="node-chara-filter__btn-in node-chara-filter__btn-in--input"
                  >
                    <div class="node-chara-filter__label">
                      <i
                        class="c-svg node-chara-filter__label-ico node-chara-filter__label-ico--input"
                      >
                        <svg class="u-hide-sp" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_input"
                          ></use>
                        </svg>
                        <svg class="u-hide-tab-pc" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_input_sp"
                          ></use>
                        </svg>
                      </i>
                    </div>
                  </div>
                </a>
              </div>
              <div class="node-chara-filter__item">
                <a
                  href="javascript:void(0);"
                  :class="{
                    'node-chara-filter__btn--active': nodeShowType === 'middle'
                  }"
                  class="node-chara-filter__btn node-chara-filter__btn--middle js-node-chara-filter-btn"
                  data-category="middle"
                  @click="filterNode('middle')"
                >
                  <div class="node-chara-filter__ico">
                    <svg
                      class="u-hide-sp"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 29 41"
                    >
                      <path
                        class="node-chara-filter__ico-svg node-chara-filter__ico-svg--middle"
                        d="M3.2,39.5,12,7.7c1.39-6,3.67-6,5.06,0L25.8,39.5Z"
                      />
                    </svg>
                  </div>
                  <div
                    class="node-chara-filter__btn-in node-chara-filter__btn-in--middle"
                  >
                    <div class="node-chara-filter__label">
                      <i
                        class="c-svg node-chara-filter__label-ico node-chara-filter__label-ico--middle"
                      >
                        <svg class="u-hide-sp" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_middle"
                          ></use>
                        </svg>
                        <svg class="u-hide-tab-pc" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_middle_sp"
                          ></use>
                        </svg>
                      </i>
                    </div>
                  </div>
                </a>
              </div>
              <div class="node-chara-filter__item">
                <a
                  href="javascript:void(0);"
                  :class="{
                    'node-chara-filter__btn--active': nodeShowType === 'output'
                  }"
                  class="node-chara-filter__btn node-chara-filter__btn--output js-node-chara-filter-btn"
                  data-category="output"
                  @click="filterNode('output')"
                >
                  <div class="node-chara-filter__ico">
                    <svg
                      class="u-hide-sp"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 29 41"
                    >
                      <path
                        class="node-chara-filter__ico-svg node-chara-filter__ico-svg--output"
                        d="M3.2,39.5,12,7.7c1.39-6,3.67-6,5.06,0L25.8,39.5Z"
                      />
                    </svg>
                  </div>
                  <div
                    class="node-chara-filter__btn-in node-chara-filter__btn-in--output"
                  >
                    <div class="node-chara-filter__label">
                      <i
                        class="c-svg node-chara-filter__label-ico node-chara-filter__label-ico--output"
                      >
                        <svg class="u-hide-sp" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_output"
                          ></use>
                        </svg>
                        <svg class="u-hide-tab-pc" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_output_sp"
                          ></use>
                        </svg>
                      </i>
                    </div>
                  </div>
                </a>
              </div>
              <div class="node-chara-filter__item">
                <a
                  href="javascript:void(0);"
                  :class="{
                    'node-chara-filter__btn--active': nodeShowType === 'mono'
                  }"
                  class="node-chara-filter__btn node-chara-filter__btn--mono js-node-chara-filter-btn"
                  data-category="mono"
                  @click="filterNode('mono')"
                >
                  <div class="node-chara-filter__ico">
                    <svg
                      class="u-hide-sp"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 29 41"
                    >
                      <path
                        class="node-chara-filter__ico-svg node-chara-filter__ico-svg--mono"
                        d="M3.2,39.5,12,7.7c1.39-6,3.67-6,5.06,0L25.8,39.5Z"
                      />
                    </svg>
                  </div>
                  <div
                    class="node-chara-filter__btn-in node-chara-filter__btn-in--mono"
                  >
                    <div class="node-chara-filter__label">
                      <i
                        class="c-svg node-chara-filter__label-ico node-chara-filter__label-ico--mono"
                      >
                        <svg class="u-hide-sp" role="img">
                          <use xlink:href="/awuxa/sprite.svg#filter_mono"></use>
                        </svg>
                        <svg class="u-hide-tab-pc" role="img">
                          <use
                            xlink:href="/awuxa/sprite.svg#filter_mono_sp"
                          ></use>
                        </svg>
                      </i>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product">
        <div class="product__in">
          <div class="product__body">
            <div class="product__info">
              <div class="product-info">
                <div class="product-info__summary product-summary">
                  <div class="product-summary-main">
                    <div class="product-summary__pkg">
                      <img src="../../assets/img/top/products/pkg.png" />
                    </div>

                    <div class="product-summary__desc">
                      <p class="product-summary__title">
                        <img src="../../assets/img/top/products/title.svg" />
                      </p>

                      <div class="product-summary__info">
                        <div class="product-summary__text">
                          <p class="product-summary__date">
                            发售日：2022年10月31日
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="product-summary-footer">
                    <div class="product-summary__format">
                      <p class="product-summary__format-label">
                        <img src="../../assets/img/top/products/format.svg" />
                      </p>
                    </div>
                    <div class="product-summary__link">
                      <a
                        href="/awuxa/products/soft.html#section02"
                        class="product-summary__link-btn"
                      >
                        <i class="c-svg product-summary__link-ico"
                          ><svg role="img">
                            <use
                              xlink:href="/awuxa/sprite.svg#arw_s_right"
                            ></use></svg
                        ></i>
                        <span class="product-summary__link-label"
                          >软件使用人数・手柄</span
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="product-info__bnr">
                  <div class="product-bnr">
                    <div class="product-bnr__soft">
                      <a
                        href="/awuxa/products/soft.html"
                        class="product-bnr-soft-bnr"
                      >
                        <div class="product-bnr-soft-bnr__in">
                          <p class="product-bnr-soft-bnr__label">
                            <img
                              src="../../assets/img/top/products/product_info.svg"
                            />
                          </p>
                          <div class="product-bnr-soft-bnr__arrow">
                            <i class="c-svg product-bnr-soft-bnr__arrow-ico"
                              ><svg role="img">
                                <use
                                  xlink:href="/awuxa/sprite.svg#arw_right"
                                ></use></svg
                            ></i>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div class="product-bnr__faq">
                      <a
                        href="/awuxa/faq/index.html"
                        class="product-bnr-faq-bnr"
                      >
                        <div class="product-bnr-faq-bnr__in">
                          <p class="product-bnr-faq-bnr__label">
                            <img src="../../assets/img/top/products/faq.svg" />
                          </p>
                          <div class="product-bnr-faq-bnr__arrow">
                            <i class="c-svg product-bnr-faq-bnr__arrow-ico"
                              ><svg role="img">
                                <use
                                  xlink:href="/awuxa/sprite.svg#arw_right"
                                ></use></svg
                            ></i>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="product-usbarea">
                <div class="product-usb">
                  <img src="../../assets/img/top/products/usb.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div
      id="js-modal-programming"
      class="js-modal-container modal-programming-container"
      :class="{ 'is-modal-shown': displayModalDelay }"
    >
      <div
        class="js-modal modal-programming"
        :class="{ 'is-modal-active': displayModal }"
      >
        <div class="js-modal-bg modal-programming__bg"></div>
        <div class="js-modal-body modal-programming__body">
          <div class="js-modal-scroll modal-programming__scroll">
            <div class="js-modal-close modal-programming-main-bg"></div>
            <div class="js-modal-main modal-programming-main">
              <div class="modal-programming-main__in">
                <div class="modal-programming-main__body">
                  <div
                    id="js-modal-programming-content"
                    class="modal-programming-sec"
                  >
                    <div class="modal-programming-sec-header">
                      <div class="modal-programming-sec-header__in">
                        <p class="modal-programming-sec-header__title">
                          <img
                            src="../../assets/img/top/modal-programming/title.svg"
                          />
                        </p>
                      </div>
                    </div>
                    <div class="modal-programming-sec-body">
                      <div class="modal-programming-sec-body__in">
                        <div class="modal-programming-sec-body__main">
                          <p class="modal-programming-sec-body__text01">
                            “程序设计”是为了让计算机实现所希望的动作，构建指令的行为。
                          </p>
                          <div class="modal-programming-sec-body__desc">
                            <div class="modal-programming-sec-body__desc-title">
                              <img
                                src="../../assets/img/top/modal-programming/desc_title.svg"
                              />
                            </div>
                            <div
                              class="modal-programming-sec-body__desc-illust"
                            >
                              <picture>
                                <source
                                  media="(max-width: 759px)"
                                  srcset="
                                    ../../assets/img/top/modal-programming/desc_illust_sp.png
                                  "
                                />
                                <img
                                  src="../../assets/img/top/modal-programming/desc_illust.png"
                                />
                              </picture>
                            </div>
                          </div>
                          <p class="modal-programming-sec-body__text02">
                            我们身边有很多东西都是通过程序设计（编程）运作的，比如地铁站的自助售卖机、平时使用的手机等。<br />另外，游戏也是由程序设计来驱动的哦。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal__close" @click="closeModal">
                  <button type="button" class="js-modal-close modal-close-btn">
                    <span class="modal-close-btn__in"
                      ><span class="modal-close-btn__ico"><i></i></span
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频弹窗 -->
    <div
      v-if="showVideoModal1"
      id="js-modal-interview"
      class="js-modal-container modal-interview-container is-modal-shown glance"
    >
      <div class="js-modal modal-interview is-modal-active">
        <div class="js-modal-bg modal-interview__bg"></div>
        <div class="js-modal-body modal-interview__body">
          <div class="js-modal-scroll modal-interview__scroll">
            <div class="js-modal-close modal-interview-main-bg"></div>
            <div class="js-modal-main modal-interview-main">
              <div class="modal-interview-main__in">
                <div class="modal-interview-main__body">
                  <div
                    id="js-modal-interview-content"
                    class="modal-interview-main__content"
                  >
                    <div
                      id="js-modal-slider"
                      class="swiper-container modal-interview-slider swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
                    >
                      <div
                        id="js-modal-interview-slide-content"
                        class="swiper-wrapper modal-interview-slider__wrapper"
                        aria-live="polite"
                      >
                        <div
                          class="swiper-slide modal-interview-slider__item swiper-slide-active"
                          role="group"
                          aria-label="1 / 1"
                          style="width: 100%;"
                        >
                          <div class="modal-interview-main__player is-active">
                            <div
                              id="js-movie-modal-content"
                              style="
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                top: 0;
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                      <span
                        class="swiper-notification"
                        aria-live="assertive"
                        aria-atomic="true"
                      ></span>
                    </div>
                    <div class="modal-interview-slider__nav">
                      <div
                        class="modal-interview-slider__arrow -prev js-modal-slidechange is-slide-none"
                      >
                        <i class="c-svg"
                          ><svg role="img">
                            <use
                              xlink:href="/awuxa/sprite.svg#arrow_left"
                            ></use></svg
                        ></i>
                      </div>
                      <div
                        class="modal-interview-slider__arrow -next js-modal-slidechange is-slide-none"
                      >
                        <i class="c-svg"
                          ><svg role="img">
                            <use
                              xlink:href="/awuxa/sprite.svg#arrow_right"
                            ></use></svg
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal__close">
                  <button
                    type="button"
                    class="js-modal-close modal-close-btn"
                    @click="showVideoModal1 = false"
                  >
                    <span class="modal-close-btn__in"
                      ><span class="modal-close-btn__ico"><i></i></span
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import '../../assets/css/vendor.css';
import '../../assets/css/common.css';
import '../../assets/css/buy-now.css';
import '../../assets/css/top.css';
import simpleSlick from '../components/simple-slick';
import pageFooter from '../components/page-footer';
import { checkWeixinBrowser, buyLinkList } from '../api';

let videoPlayer1 = {};

const leadBreakPoints = [
  {
    breakpoint: 759,
    settings: {
      slidesToShow: 1.52,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 980,
    settings: {
      slidesToShow: 2.9,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1100,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 3.1,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1480,
    settings: {
      slidesToShow: 3.3,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1520,
    settings: {
      slidesToShow: 3.5,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1580,
    settings: {
      slidesToShow: 3.6,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1680,
    settings: {
      slidesToShow: 3.7,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1780,
    settings: {
      slidesToShow: 3.8,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2020,
    settings: {
      slidesToShow: 4.4,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2120,
    settings: {
      slidesToShow: 4.8,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2220,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2320,
    settings: {
      slidesToShow: 5.2,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2420,
    settings: {
      slidesToShow: 5.4,
      slidesToScroll: 1
    }
  }
];
const nodeBreakPoints = [
  {
    breakpoint: 759,
    settings: {
      slidesToShow: 5,
      speed: 6000,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1100,
    settings: {
      slidesToShow: 9,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1300,
    settings: {
      slidesToShow: 9.5,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 10,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1500,
    settings: {
      slidesToShow: 10.5,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1800,
    settings: {
      slidesToShow: 11,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 1900,
    settings: {
      slidesToShow: 12,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2000,
    settings: {
      slidesToShow: 13,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2100,
    settings: {
      slidesToShow: 14,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2200,
    settings: {
      slidesToShow: 15,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2300,
    settings: {
      slidesToShow: 16,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 2400,
    settings: {
      slidesToShow: 17,
      slidesToScroll: 1
    }
  }
];
function chunk(array, size) {
  const chunked = [];
  let index = 0;
  while (index < array.length) {
    chunked.push(array.slice(index, index + size));
    index += size;
  }
  return chunked;
}
function nl2br(str) {
  const _str = str.replace(/[\n]/g, '<br>');
  return _str;
}
export default {
  components: {
    simpleSlick,
    swiper,
    swiperSlide,
    pageFooter
  },
  data() {
    return {
      buyLinkList,
      displayModal: false,
      displayModalDelay: false,
      leadHeight: 0,
      leadSpeed: 0.4,
      leadTime: 12000,
      windowWidth: 1280,
      leadList1: [
        { src: require('/assets/img/top/lead/11.jpg') },
        { src: require('/assets/img/top/lead/12.jpg') },
        { src: require('/assets/img/top/lead/13.jpg') },
        { src: require('/assets/img/top/lead/14.jpg') },
        { src: require('/assets/img/top/lead/15.jpg') },
        { src: require('/assets/img/top/lead/16.jpg') },
        { src: require('/assets/img/top/lead/17.jpg') },
        { src: require('/assets/img/top/lead/18.jpg') },
        { src: require('/assets/img/top/lead/19.jpg') },
        { src: require('/assets/img/top/lead/20.jpg') }
      ],
      leadList2: [
        { src: require('/assets/img/top/lead/01.jpg') },
        { src: require('/assets/img/top/lead/02.jpg') },
        { src: require('/assets/img/top/lead/03.jpg') },
        { src: require('/assets/img/top/lead/04.jpg') },
        { src: require('/assets/img/top/lead/05.jpg') },
        { src: require('/assets/img/top/lead/06.jpg') },
        { src: require('/assets/img/top/lead/07.jpg') },
        { src: require('/assets/img/top/lead/08.jpg') },
        { src: require('/assets/img/top/lead/09.jpg') },
        { src: require('/assets/img/top/lead/10.jpg') }
      ],
      swiperOption: {
        loop: false,
        longSwipesRatio: 0.45,
        threshold: 10,
        watchOverflow: true,
        speed: 750,
        pagination: {
          el: '.js-node-slide-pagination',
          clickable: true
        },
        navigation: {
          prevEl: '.node-slide-container__main-arw--prev',
          nextEl: '.node-slide-container__main-arw--next'
        },
        on: {
          realIndexChange() {
            const currentIndex = this.realIndex;
            const swiperVideos = document.getElementsByClassName(
              'js-node-slide-video'
            );
            [...swiperVideos].forEach((v) => {
              v.pause();
            });
            const currentVideo = document.getElementsByClassName(
              `js-node-slide-video${currentIndex}`
            );
            currentVideo[0].currentTime = 0;
            currentVideo[0].play();
          }
        }
      },
      nodeList: [],
      nodeType: 'all',
      nodeSelected: null,
      nodeListSize: 22,
      nodeTime: 12000,
      nodeShowType: 'all',
      nodeConfig: {
        all: {
          node: null,
          category: 'all'
        },
        input: {
          node: null,
          category: 'input',
          text: '输入'
        },
        middle: {
          node: null,
          category: 'middle',
          text: '中间'
        },
        output: {
          node: null,
          category: 'output',
          text: '输出'
        },
        mono: {
          node: null,
          category: 'mono',
          text: '物体'
        }
      },
      activeNodeDelay: true, // 动画冲突，增加delay处理
      nodeChangeDelay: true,
      showVideoModal1: false
    };
  },
  computed: {
    leadBottomStyle() {
      return {
        height: `${this.leadHeight}px`
      };
    },
    leadShowNum() {
      const point = leadBreakPoints.findIndex(
        (p) => this.windowWidth < p.breakpoint
      );
      if (point !== -1) {
        return leadBreakPoints[point].settings.slidesToShow;
      }
      return 5.6;
    },
    nodeShowNum() {
      const point = nodeBreakPoints.findIndex(
        (p) => this.windowWidth < p.breakpoint
      );
      if (point !== -1) {
        return nodeBreakPoints[point].settings.slidesToShow;
      }
      return 18;
    },
    showNodeList() {
      return chunk(this.nodeList, this.nodeListSize);
    },
    nodeSelectedClass() {
      if (this.nodeSelected) {
        return `node-chara-info node-chara-info--${this.nodeSelected.category}`;
      }
      return 'node-chara-info';
    },
    nodeSelectedStyle() {
      if (this.nodeSelected && this.nodeChangeDelay) {
        return {
          opacity: 1,
          transform: 'scale(1, 1)',
          transition: 'all 0.3s cubic-bezier(0.64, 1, 0.34, 1.5)'
        };
      }
      return {
        opacity: 0,
        transform: 'scale(0,0)'
      };
    },
    nodeSelectedImg() {
      if (this.nodeSelected) {
        return this.nodeSelected.imgSrc;
      }
      return '';
    },
    nodeSelectedName() {
      if (this.nodeSelected) {
        return this.nodeSelected.name;
      }
      return '';
    },
    nodeSelectedCategory() {
      if (this.nodeSelected) {
        return this.nodeConfig[this.nodeSelected.category].text;
      }
      return '';
    },
    nodeSelectedText() {
      if (this.nodeSelected) {
        return nl2br(this.nodeSelected.text);
      }
      return '';
    }
  },
  watch: {
    showVideoModal1(newVal) {
      if (newVal) {
        window.document
          .querySelector('html')
          .classList.add('is-modal-opened', 'is-modal-scrollbar-shown');

        setTimeout(() => {
          videoPlayer1 = new Txplayer({
            containerId: 'js-movie-modal-content',
            vid: 'a3370qu3yt4',
            width: '100%',
            height: '100%',
            autoplay: true,
            platform: '5410201',
            sdtfrom: 'v1012',
            miniSkinAdaptive: false
          });
        });
      } else {
        window.document
          .querySelector('html')
          .classList.remove('is-modal-opened', 'is-modal-scrollbar-shown');
        videoPlayer1.destroy();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.setLeadHeight();
      this.getWindowWidth();
    });
    const w = this.getWindowWidth();
    if (w < 760) {
      this.nodeListSize = 17;
    }
    this.initNodes();
    const isWeixin = checkWeixinBrowser();
    if (isWeixin) {
      // 微信浏览器自动播放视频
      document.body.addEventListener('touchstart', function () {
        const videos = [...document.getElementsByTagName('video')];
        videos.forEach((v) => {
          if (v.getAttribute('autoplay')) {
            v.play();
          }
        });
      });
    }
  },
  methods: {
    getWindowWidth() {
      this.windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      return this.windowWidth;
    },
    setLeadHeight() {
      setTimeout(() => {
        const leadBg = document.getElementsByClassName('lead-bg')[0];
        const leadMain = document.getElementsByClassName('lead__main')[0];
        if (leadBg && leadMain) {
          this.leadHeight = leadBg.offsetHeight - leadMain.offsetHeight;
        }
      });
    },
    slideNext(e) {
      // 如果在视野，进行自动切换，不在时循环播放
      const videoEle = e.currentTarget;
      const bounding = videoEle.getBoundingClientRect();

      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= window.innerWidth &&
        bounding.bottom <= window.innerHeight
      ) {
        this.$refs.swiper.swiper.slideNext();
      } else {
        videoEle.currentTime = 0;
        videoEle.play();
      }
    },
    initNodes() {
      const nodes = require('/assets/data/node.json');
      nodes.forEach((n) => {
        n.imgSrc = require(`/assets/img/node/${n.file}.png`);
      });
      // 打乱顺序
      const shuffledNode = this.getShuffleNode(nodes);
      // 默认全部节点
      this.nodeConfig.all.node = nodes[1] || nodes[0];
      // 默认输入节点
      const inputNodeIndex = nodes.findIndex(
        (n) => n.category === this.nodeConfig.input.category
      );
      this.nodeConfig.input.node = nodes[inputNodeIndex];
      // 默认中间节点
      const middleNodeIndex = nodes.findIndex(
        (n) => n.category === this.nodeConfig.middle.category
      );
      this.nodeConfig.middle.node = nodes[middleNodeIndex];
      // 默认输出节点
      const outputNodeIndex = nodes.findIndex(
        (n) => n.category === this.nodeConfig.output.category
      );
      this.nodeConfig.output.node = nodes[outputNodeIndex];
      // 默认物体节点
      const monoNodeIndex = nodes.findIndex(
        (n) => n.category === this.nodeConfig.mono.category
      );
      this.nodeConfig.mono.node = nodes[monoNodeIndex];
      this.nodeList = shuffledNode;
    },
    getShuffleNode(array) {
      // 随机取下标，然后一个个交换
      const list = [...array];
      let i = list.length;
      while (i) {
        const j = Math.floor(Math.random() * i);
        i -= 1;
        const t = list[i];
        list[i] = list[j];
        list[j] = t;
      }
      return list;
    },
    clickNodeHandler(item) {
      if (item) {
        if (
          this.nodeShowType !== 'all' &&
          this.nodeShowType !== item.category
        ) {
          // filtered
          return;
        }
        this.nodeSelected = item;
        this.nodeChangeDelay = false;
        setTimeout(() => {
          this.nodeChangeDelay = true;
        });
      } else {
        // 默认展示“按键小节点”
        this.nodeSelected = this.nodeConfig.all.node;
        this.nodeChangeDelay = false;
        setTimeout(() => {
          this.nodeChangeDelay = true;
        });
      }
    },
    filterNode(category) {
      // 过滤节点
      if (this.nodeShowType !== category) {
        if (this.nodeShowType !== 'all') {
          // 动画冲突处理
          this.activeNodeDelay = false;
          setTimeout(() => {
            this.activeNodeDelay = true;
          }, 500);
        }
        this.nodeShowType = category;
        this.clickNodeHandler(this.nodeConfig[category].node);
      }
    },
    showModal() {
      document.querySelector('html').classList.add('is-modal-opened');
      this.displayModal = true;
      this.displayModalDelay = true;
    },
    closeModal() {
      this.displayModal = false;
      setTimeout(() => {
        this.displayModalDelay = false;
        document.querySelector('html').classList.remove('is-modal-opened');
      }, 1000);
    }
  }
};
</script>

<style>
.showNode {
  transform: scale(1, 1);
  transition: transform 0.3s cubic-bezier(0.34, 1, 0.64, 1);
  transition-delay: 500ms;
}
.filterNode {
  transform: scale(0, 0);
  transition: transform 0.5s cubic-bezier(0.34, -1, 0.64, 1);
}
.showHover {
  transition: transform 0.3s cubic-bezier(0.34, 1, 0.64, 1);
  transform: scale(0.55, 0.55);
  transition-delay: 500ms;
}
.filterHover {
  transform: scale(0, 0);
  transition: transform 0.5s cubic-bezier(0.34, -1, 0.64, 1);
}
</style>
